/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type AddPackageForm = {
  /**
   * The name of the package to add.
   */
  name: string;
  /**
   * The version of the package to add. If omitted, the latest version will be used.
   */
  version?: string | undefined;
};

/** @internal */
export type AddPackageForm$Outbound = {
  name: string;
  version?: string | undefined;
};

/** @internal */
export const AddPackageForm$outboundSchema: z.ZodMiniType<
  AddPackageForm$Outbound,
  AddPackageForm
> = z.object({
  name: z.string(),
  version: z.optional(z.string()),
});

export function addPackageFormToJSON(addPackageForm: AddPackageForm): string {
  return JSON.stringify(AddPackageForm$outboundSchema.parse(addPackageForm));
}
